import { Button } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import sharedStyles from '../Shared.module.scss';
import styles from './ScenarioNoAssets.module.scss';

export interface ScenarioNoAssetsProps {
  label?: string;
  onClick?: () => void;
  hasNoConditions: boolean;
}

export const ScenarioNoAssets = ({
  label,
  onClick,
  hasNoConditions,
}: ScenarioNoAssetsProps) => {
  const { t } = useTranslation('scenario');

  const titleText = hasNoConditions
    ? t('scenario:emptyState.selectAssetsAndConditions')
    : t('scenario:emptyState.selectAssets');

  const descriptionText = hasNoConditions
    ? t('scenario:emptyState.addAssetsAndConditions')
    : t('scenario:emptyState.addAssetsToInitiateAnalysis');

  return (
    <div className={sharedStyles.container} data-testid="scenario-no-assets">
      <img
        className={sharedStyles.img}
        src="/app/static/images/icons/no-assets-found.svg"
        alt=""
      />
      <div className={styles.description}>
        <p className={sharedStyles.title}>{titleText}</p>
        <p className={sharedStyles.message}>{descriptionText}</p>
      </div>

      <Button
        data-testid="scenario-add-assets-button"
        variant={'secondary'}
        size="medium"
        label={label}
        onClick={onClick}
      />
    </div>
  );
};
